import { Platform } from 'react-native';
import { getBottomSpace } from 'react-native-iphone-screen-helper';
import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const Content = styled.ScrollView`
  padding: 0 24px;
`;

export const Title = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(14)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const Text = styled.Text`
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  margin-top: ${RFValue(12)}px;
`;

export const TitleContent = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  margin-top: ${RFValue(12)}px;
`;

export const ContentSection = styled.View``;

export const Footer = styled.View`
  padding: 0 24px;
  padding-top: ${RFValue(12)}px;
  padding-bottom: ${getBottomSpace() && Platform.OS === 'ios'
    ? 0
    : RFValue(20)}px;
`;
